/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * For a picklist item, send the ids from the picklist option. For a one-off item, send only name. Ids and name together are rejected.
 * @export
 * @interface CreateLeadTaskWorkflowItemRequest
 */
export interface CreateLeadTaskWorkflowItemRequest {
    /**
     * 
     */
    task_workflow_item_id?: string;
    /**
     * 
     */
    task_workflow_item_org_configuration_id?: string;
    /**
     * 
     */
    name?: string;
}

/**
 * Check if a given object implements the CreateLeadTaskWorkflowItemRequest interface.
 */
export function instanceOfCreateLeadTaskWorkflowItemRequest(value: object): value is CreateLeadTaskWorkflowItemRequest {
    return true;
}

export function CreateLeadTaskWorkflowItemRequestFromJSON(json: any): CreateLeadTaskWorkflowItemRequest {
    return CreateLeadTaskWorkflowItemRequestFromJSONTyped(json, false);
}

export function CreateLeadTaskWorkflowItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadTaskWorkflowItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'task_workflow_item_id': json['task_workflow_item_id'] == null ? undefined : json['task_workflow_item_id'],
        'task_workflow_item_org_configuration_id': json['task_workflow_item_org_configuration_id'] == null ? undefined : json['task_workflow_item_org_configuration_id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CreateLeadTaskWorkflowItemRequestToJSON(json: any): CreateLeadTaskWorkflowItemRequest {
    return CreateLeadTaskWorkflowItemRequestToJSONTyped(json, false);
}

export function CreateLeadTaskWorkflowItemRequestToJSONTyped(value?: CreateLeadTaskWorkflowItemRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'task_workflow_item_id': value['task_workflow_item_id'],
        'task_workflow_item_org_configuration_id': value['task_workflow_item_org_configuration_id'],
        'name': value['name'],
    };
}

